/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../../../../theme';

export const CreateLabelContainerStyled = styled.div.attrs({
    className: 'create-label',
})`
    position: relative;
`;

export const CreateLabelButtonTextStyled = styled.div`

`;

export const CreateLabelButtonStyled = styled.div.attrs({
    className: 'create-label__action-button',
    id: 'create-label__button',
})<{ icon: string; open: boolean }>`
    width: 48px;
    height: 48px;
    border: ${(props) => props.open ? '1px solid transparent' : '1px solid ' + colors.labelEditorCreateBorder};
    background: url(${(props) => props.icon}) no-repeat center;
    background-color: ${(props) => props.open ? colors.labelEditorCreateBgActive : colors.labelEditorCreateBg};
    border-radius: 50%;
    cursor: pointer;

    &:after {
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 7.5px solid transparent;
        border-right: 7.5px solid transparent;
        border-bottom: 8px solid ${colors.labelEditorCreateBg};
        content: '';
    }
`;

export const CreateLabelModalContainerStyled = styled.div.attrs({
    className: 'create-label__modal-window',
})`
    position: absolute;
    top: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    display: flex;
    flex-direction: column;
    padding: 16px;
    width: 312px;
    background: ${colors.labelEditorModuleBg};
    box-shadow: 0 2px 12px 0 ${colors.labelEditorCreateShadow};

    .create-label__save-button {
        display: block;
        margin-top: 16px;
        width: 100%;

        button {
            width: 100%;
        }
    }
`;
